import SignInForm from "../organisms/forms/signIn/SignInForm";
import SignUpForm from "../organisms/forms/signUp/SignUpForm";
import { useTranslation } from "react-i18next";
import Content from "../templates/wrapper/Content";
import TabsRoot from "../molecules/tabs/TabsRoot";

const SignUpPage = () => {
  const { t } = useTranslation();
  const tabsData = [
    { value: "signIn", label: t("signUp.login"), content: <SignInForm /> },
    {
      value: "signUp",
      label: t("signUp.createAccount"),
      content: <SignUpForm />,
    },
  ];
  return (
    <>
      <Content>
        <TabsRoot tabs={tabsData} defaultValue="signUp" />
      </Content>
    </>
  );
};

export default SignUpPage;
